import React, { memo, Fragment } from "react";
import { defineMessages } from "react-intl";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { OutlinedButton } from "../button/Buttons.js";
import "../button/EditButton.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useClasses = makeStyles()(() => ({
  goBackButtonIcon: {
    fontSize: "8px !important",
    transform: "rotate(90deg)"
  }
}));
const localized = defineMessages({
  backButtonLabel: {
    id: "backButtonLabel",
    defaultMessage: "Back"
  }
});
function BackButton({ onBack }) {
  const { classes } = useClasses();
  const handleOnClick = () => {
    onBack();
  };
  return /* @__PURE__ */ React.createElement(Fragment, null, /* @__PURE__ */ React.createElement(
    OutlinedButton,
    {
      size: "small",
      label: localized.backButtonLabel,
      startIcon: /* @__PURE__ */ React.createElement(Box, { component: "span", className: `${CustomIcon.ArrowDown} ${classes.goBackButtonIcon}` }),
      onClick: handleOnClick
    }
  ));
}
const BackButton$1 = memo(BackButton);
export {
  BackButton$1 as default
};
//# sourceMappingURL=BackButton.js.map
